import FollowUpStages from "./FollowUpStages";

export default FollowUpStages;